export default "# Render\n\n::demo{name=render_demo}\n"